/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_No_Shared_FilesInputs */

const en_google_drive_no_shared_files = /** @type {(inputs: Google_Drive_No_Shared_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No files yet. Choose files from Google Drive to make them available here.`)
};

const es_google_drive_no_shared_files = /** @type {(inputs: Google_Drive_No_Shared_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay archivos. Elige archivos de Google Drive para que aparezcan aquí.`)
};

/**
* | output |
* | --- |
* | "No files yet. Choose files from Google Drive to make them available here." |
*
* @param {Google_Drive_No_Shared_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_no_shared_files = /** @type {((inputs?: Google_Drive_No_Shared_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_No_Shared_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_no_shared_files(inputs)
	return en_google_drive_no_shared_files(inputs)
});